/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {afterNextRender, ChangeDetectionStrategy, Component, inject, OnInit} from '@angular/core';
import {SwUpdate, VersionReadyEvent} from '@angular/service-worker';
import {NbDialogService, NbLayoutModule} from '@nebular/theme';
import {VersionReadyDialogComponent} from 'compob2b-libs';
import {filter, tap} from 'rxjs/operators';
import {AnalyticsInjectorService} from './cabinet/shared/seo/analytics-injector.service';
import {ImageFallbackService} from './cabinet/shared/image-fallback/image-fallback.service';
import {RouterOutlet} from '@angular/router';
import {TuiRoot} from '@taiga-ui/core';
import {LoadingBarModule} from '@ngx-loading-bar/core';

@Component({
  selector: 'app-compo',
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TuiRoot, NbLayoutModule, RouterOutlet, LoadingBarModule],
})
export class AppComponent implements OnInit {
  private open = false;
  private readonly analytics = inject(AnalyticsInjectorService);
  private readonly imageFallback = inject(ImageFallbackService);

  constructor(private swUpdate: SwUpdate,
              private dialogService: NbDialogService) {
    // Браузер-only side-effects, один раз после гидрации (afterNextRender не идёт на сервере):
    // — счётчики аналитики (GA4/GTM/Метрика), конфиг из SEO_CONFIG;
    // — резервный домен картинок (тестовые окружения): при ошибке загрузки фото
    //   вторая попытка с serverPicturesPathFallback (no-op, если резерв не задан).
    afterNextRender(() => {
      this.analytics.inject();
      this.imageFallback.register();
    });
  }

  ngOnInit() {
    if (this.swUpdate.isEnabled) {
      this.swUpdate.versionUpdates.pipe(
        tap(console.warn),
        filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY')
      ).subscribe(_ => {
        if (this.open) {
          return;
        }
        this.open = true;
        this.dialogService.open(VersionReadyDialogComponent, {
          dialogClass: 'simple',
          hasBackdrop: false,
          closeOnBackdropClick: false,
          closeOnEsc: false
        });
      });
    }

    // SEO meta — каждая SSR-страница (Dashboard, CatalogList, ProductView,
    // NewsElement, Promotion, TextPage) сама зовёт `seo.apply(...)`.
    // SeoMetaService автоматически использует siteName из /init как title
    // fallback и строит canonical (с query string) через CanonicalUrlBuilder.
  }
}
